<template>
  <div :class="customClass" class="reward-card-main-container d-flex">
    <div class="reward-card-container rounded d-flex" :style="`border-color:${sectionColor};`">
      <img
        v-if="isDaily && !userIsAParent"
        class="daily-reward-badge"
        src="@/assets/button-style/Daily-Reward.png"
        alt="reward-card"
      />
      <div class="reward-card-content">
        <label class="reward-card-content__title">{{ rewardData.name }}</label>
        <div class="reward-card-content__t">
          <button class="claim-reward-button" @click="onClaimReward" :style="styleRewardBtn">
            <label v-if="rewardData.claimed" class="cursor-pointer">Reward claimed</label>
            <label v-else-if="!rewardData.available" class="cursor-pointer"
              >You still need {{ rewardData.stars_missing }} {{ currencyWord.toLowerCase() }}</label
            >
            <label v-else class="cursor-pointer">Claim it!</label>
          </button>
        </div>
      </div>
      <div
        class="col-4 p-0 position-relative reward-card-image"
        :style="
          rewardData.attachment
            ? `background-image:url(${rewardData.attachment});`
            : `background-color:${sectionColor};`
        "
      >
        <div
          class="reward-card-icon position-absolute rounded-circle d-flex justify-content-center align-items-center"
          :style="`background-color:${iconColor};`"
        >
          <span class="material-icons align-middle large text-white">
            card_giftcard
          </span>
        </div>
        <div class="missing-star-icon">
          {{ rewardData.stars_required }}
        </div>
        <div @blur="showOptions = false" tabindex="0" v-if="isOnParent && !isDuplicateActivate">
          <div
            @click="openOptions"
            class="reward-options-button border-0 bg-transparent position-absolute p-0"
          >
            <span class="material-icons">
              more_horiz
            </span>
          </div>
          <div
            ref="rewardoptions"
            v-if="showOptions"
            class="reward-options-content position-absolute"
          >
            <div
              v-if="!rewardData.claimed"
              class="reward-options-content__option border-0 bg-white d-flex justify-content-end align-items-center "
              @click="() => onEditReward()"
            >
              <span class="no-pointer-event">Edit</span>
              <span class="no-pointer-event material-icons align-middle small px-2">
                mode_edit
              </span>
            </div>
            <div
              class="reward-options-content__option border-0 bg-white d-flex justify-content-end align-items-center "
              @click="() => onDeleteReward()"
            >
              <span class="no-pointer-event">Delete</span>
              <span class="no-pointer-event material-icons align-middle small px-2">
                delete
              </span>
            </div>
          </div>
        </div>
        <checkboxCardReward
          class="checkbox-card-rewards"
          v-else-if="isDuplicateActivate"
          :idCheckbox="rewardData.name + rewardData.id"
          :label="rewardData.name"
          :checked="isSelectedToDuplicate"
          @change="duplicateSelectOnChange"
        ></checkboxCardReward>
      </div>
    </div>
  </div>
</template>
<script>
import checkboxCardReward from './checkboxCardReward.vue';
import { mapGetters, mapState } from 'vuex';
export default {
  props: {
    customClass: String,
    sectionColor: {
      type: String,
      default: '#DEF0FE',
    },
    iconColor: {
      type: String,
      default: '#98CCFF',
    },
    rewardData: {
      type: Object,
      default: null,
      require: true,
    },
    canClaim: {
      type: Boolean,
      default: false,
    },
    isDaily: {
      type: Boolean,
      default: false,
    },
    editReward: {
      type: Function,
      default: () => {
        return;
      },
    },
    deleteReward: {
      type: Function,
      default: () => {
        return;
      },
    },
    claimReward: {
      type: Function,
      default: () => {
        return;
      },
    },
    starsBanked: {
      type: Number,
      default: 0,
      require: true,
    },
    currencyWord: {
      type: String,
      default: 'Stars',
    },
    rewardsToDuplicate: {
      type: Array,
      default: () => [],
    },
  },
  components: { checkboxCardReward },
  data() {
    return {
      showOptions: false,
      isOnParent: false,
      isSelectedToDuplicate: false,
    };
  },
  methods: {
    openOptions() {
      this.showOptions = true;
    },
    onDeleteReward() {
      this.deleteReward(this.rewardData);
    },
    onEditReward() {
      this.editReward(this.rewardData);
      this.showOptions = false;
    },
    onClaimReward() {
      const { id, name, attachment, available, claimed } = this.rewardData;

      if (available && !claimed) this.claimReward(id, name, attachment);
    },
    duplicateSelectOnChange(isSelected) {
      this.isSelectedToDuplicate = isSelected;
      this.$emit('duplicate-select-change', isSelected);
    },
  },
  computed: {
    ...mapState('rewards', ['isDuplicateActivate']),
    ...mapGetters('user', ['userIsAParent']),
    styleRewardBtn() {
      const { claimed, stars_missing } = this.rewardData;
      const backgroundColor = claimed ? '#1E90FF' : stars_missing ? '#CED4DA' : '#46CC8D';
      const color = !stars_missing || claimed ? '#FFF' : undefined;

      return { backgroundColor, color };
    },
  },
  watch: {
    isDuplicateActivate(value) {
      if (!value) {
        this.isSelectedToDuplicate = false;
      }
    },
  },
  mounted() {
    this.isOnParent = this.userIsAParent;
  },
};
</script>

<style scoped lang="scss">
* {
  position: relative;
  margin: 0;
  padding: 0;
}
.no-pointer-event {
  pointer-events: none;
}
.reward-card-main-container {
  .reward-card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    padding: 10px;

    .reward-card-content__title {
      color: #040404;
      font-weight: 600;
      font-size: 1rem;
      margin-right: 5px;

      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .reward-card-content__price {
      color: #fd7e14;
      font-size: 0.8rem;
      font-weight: 500;
    }

    .reward-stars-needed {
      color: black;
      font-size: 0.9rem;
      font-weight: 500;
    }

    .reward-stars-missing {
      color: #040404;
      font-weight: 500;
      font-size: 19px;
    }
  }
  .missing-reward-stars {
    height: 21px;
    width: 100%;
  }

  .claim-reward-button {
    width: 100%;
    width: 95%;
    font-size: 0.8rem;
    font-weight: 500;
    text-align: center;
    border-radius: 50px;
    border: none;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .cursor-default {
    cursor: default;
  }
  .reward-card-container {
    width: 100%;
    height: 130px;
    max-height: 130px;

    box-shadow: 3px 3px 6px #00000029;
    border: 2px solid #def0fe;

    .daily-reward-badge {
      position: absolute;
      top: -20px;
      left: -15px;
    }

    .reward-card-icon {
      width: 54px; //3.375rem;
      height: 54px; //3.375rem;
      top: calc(50% - 1.688rem);
      left: -27px; //-1.688rem;
      * {
        font-size: 30px;
      }
    }

    .reward-options-button {
      cursor: pointer;
      top: 6px;
      right: 6px;
      color: #416b69;
    }

    .reward-options-content {
      z-index: 20;
      top: 6px;
      right: 6px;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: 3px 3px 6px #00000029;
      border: 1px solid #ced4da;
      .reward-options-content__option {
        cursor: pointer;
        border-radius: 4px;
        width: 105px;
        height: 30px;
      }
    }
  }

  .reward-card-image {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}

.missing-star-icon {
  position: absolute;
  bottom: 0;
  right: 0;

  width: 3rem;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
  font-size: 0.8em;

  color: #fff;
  background-image: url('~@/assets/icons/RewardStar.svg');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.checkbox-card-rewards {
  position: absolute;
  top: 0.2em;
  right: 0.2em;

  width: fit-content;
}
</style>
